/* eslint-disable max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const GET_REWARD_TEXT = (
    <FormattedMessage
        id='get_reward.text'
        defaultMessage='Получить награду'
    />
)

export const GET_REWARD_TITLE = (
    <FormattedMessage
        id='get_reward.title'
        defaultMessage='Награда за достижения в личном рейтинге'
    />
)

export const GET_REWARD_NOT_AVAILABLE = (
    <FormattedMessage
        id='get_reward.not.available'
        defaultMessage='У вас нет начисленных и доступных для получения наград'
    />
)

export const GET_REWARD_REWARD_RECEIVED = (
    <FormattedMessage
        id='get_reward.reward.received'
        defaultMessage='Следующее определение позиции в рейтинге и размера награды произойдет после расчёта хода на Глобальной карте'
    />
)

export const GET_REWARD_REWARD_RECEIVED_TITLE = (
    <FormattedMessage
        id='get_reward.reward.received.title'
        defaultMessage='Награда начислена на ваш аккаунт'
    />
)


// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/components/Footer/translations.jsx